import styled from "styled-components";
import { Card, Button } from "semantic-ui-react";
import { Svg } from "../../../assets";
import { theme } from "../../../styling/theme";

const defaultImage = Svg.PromptPlaceholder;

export const StickerCardStyle = styled(Card)({
  background: `${theme.lightBackgroundColor} !important`,
  borderRadius: "5px !important",
  border: `1px solid ${theme.backgroundColor} !important`,
  boxShadow: `none !important`,
  width: "130px !important",
  margin: "0 !important",
});

export const DeleteButton = styled(Button)({
  position: "absolute",
  top: "0px",
  right: "0px",
  background: "white !important",
  color: theme.buttonColor + " !important",
  height: "40px",
  width: "40px !important",
  padding: "10px !important",
});
